module.exports = __webpack_public_path__ + "static/media/1_15.dde211fa.jpg";